import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import AddressList from "Constants/AddressList";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import {
  changeProjectSearch,
  getAllProjectCustomerList,
  getCustomerList,
  getGrouhMoshtari_v2,
  selectCustomerForAdmin,
  updateProject,
} from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import {
  ALL_PROJECT_LIST,
  SELECTED_CUSTOMER,
  SELECTED_CUSTOMER_ADMIN,
  SELECTED_PROJECT,
  SHOW_PROJECTS,
} from "Stores/actionTypes";
import * as Icons from "react-bootstrap-icons";

function EditProjectDialog({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    selectedUser,
    projectsListPagination,
    projectDataSearch,
    allCustomerForAdmin,
    allCustomers,
    selectedProject,
  } = useSelector((state) => ({
    selectedUser: state.project.selectedUser,
    projectsListPagination: state.project.projectsListPagination,
    projectDataSearch: state.project.projectDataSearch,
    allCustomerForAdmin: state.project.allCustomerForAdmin,
    allCustomers: state.project.allCustomers,
    selectedProject: state.project.selectedProject,
  }));

  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [newCustomerValid, setNewCustomerValid] = useState({});
  const [newCustomer, setNewCustomer] = useState(false);
  const [noCustomer, setNoCustomer] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [formDisable, setFormDisable] = useState(true);
  const [change, setChange] = useState(false);
  const [controls, setControls] = useSetState({
    projectName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      row: 1,
      col: {
        sm: 12,
        xs: 12,
      },
    },
    customers: {
      type: "select",
      label: "customers_name_input",
      selectItems: [],
      hasFunction: {
        onClick: () => toggleNewCustomer(),
        unClickedLabel: {
          label: "newCustomer",
          icon: <Icons.Plus />,
        },
        clickedLabel: {
          label: "enseraf",
          icon: <Icons.X />,
        },
      },
      value: "",
      validation: null,
      row: 1,
      col: {
        sm: 12,
        xs: 12,
      },
    },
    customerGroup: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      row: 2,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    customerName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      row: 2,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    mobile: {
      type: "mobile",
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        isPhoneSignUp: true,
      },
      row: 2,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    ostan: {
      type: "select",
      selectItems: AddressList.Ostan,
      value: "",
      validation: null,
      row: 3,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    city: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      row: 3,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    address: {
      type: "text",
      value: "",
      validation: null,
      row: 3,
      col: {
        sm: 12,
        xs: 12,
      },
    },
    maliyat: {
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
      row: 3,
      col: {
        sm: 4,
        xs: 4,
      },
    },
    nasb: {
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
      row: 3,
      col: {
        sm: 4,
        xs: 4,
      },
    },
    mavadMasrafi: {
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
      row: 3,
      col: {
        sm: 4,
        xs: 4,
      },
    },
  });

  const toggleNewCustomer = () => {
    if (!noCustomer) setNewCustomer(!newCustomer);
    else setNewCustomer(true);
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    if (name === "customerName" || name === "mobile") {
      setNewCustomerValid((prev) => ({ ...prev, [name]: validation }));
    } else {
      setFormValid((prev) => ({ ...prev, [name]: validation }));
    }
    setChange(true);
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    formValid[controlName] = true;
    if (controlName === "ostan") {
      const ctSelectItems = AddressList.city.filter(
        (s) => s.ostan === value.value,
      );
      setControls({ city: { selectItems: ctSelectItems } });
      setControls({ city: { value: ctSelectItems[0] } });
    }
    setChange(true);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    let main_result =
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true);
    let additional_result = true;
    if (newCustomer)
      additional_result =
        !R.isEmpty(newCustomerValid) &&
        Object.values(newCustomerValid).every((item) => item === true);
    if (main_result && additional_result) {
      const {
        projectName,
        city,
        ostan,
        address,
        maliyat,
        nasb,
        mavadMasrafi,
        customers,
        customerGroup,
        customerName,
        mobile,
      } = controls;
      try {
        let _mobile = mobile.value;
        if (mobile.value.charAt(0) === "0")
          _mobile = mobile.value.replace("0", "");
        const data = {
          Id: row.Id,
          KeyGroup: read("groupKey"),
          KeyUser:
            newCustomer && selectedUser ? selectedUser.Key : read("userKey"),
          Name: projectName.value,
          IdCustomer: newCustomer ? -1 : customers.value.value,
          IdGroupCustomer: newCustomer
            ? customerGroup.value.Id
            : customers.value.IdGroupCustomer,
          NameCustomer: newCustomer
            ? customerName.value
            : customers.value.label,
          Mobile: newCustomer ? _mobile : "",
          IdCity: city.value.value,
          Tax: +maliyat.value,
          CostInstall: +nasb.value,
          CostMaterial: +mavadMasrafi.value,
          Address: address.value,
        };
        const update_status = await dispatch(updateProject(data));
        if (update_status) {
          if (selectedProject.Id === row.Id) {
            dispatch({
              type: SELECTED_PROJECT,
              selectedProject: {
                ...selectedProject,
                Name: projectName.value,
                NameCity: `${ostan.value.label} - ${city.value.label}`,
                NameCustomer: newCustomer
                  ? customerName.value
                  : customers.value.label,
                Address: address.value,
                Tax: +maliyat.value,
                CostInstall: +nasb.value,
                CostMaterial: +mavadMasrafi.value,
              },
            });
            dispatch({
              type: SHOW_PROJECTS,
              value: false,
            });
          }
          if (!newCustomer) {
            dispatch(
              changeProjectSearch({
                ...projectDataSearch,
                customers: customers.value,
                changeOut: true,
              }),
            );
          } else {
            if (["1", "5"].includes(read("StypeU")) && read("UserC") === "-") {
              const paramsCustomer = {
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
                KeyRequestUser: selectedUser.Key,
                All: true,
              };
              const responseCustomer = await dispatch(
                selectCustomerForAdmin(paramsCustomer),
              );
              if (responseCustomer.length > 0) {
                dispatch({
                  type: SELECTED_CUSTOMER_ADMIN,
                  selectedCustomerAdmin: responseCustomer[0],
                });
                const paramsList = {
                  KeyGroup: read("groupKey"),
                  KeyUser: read("userKey"),
                  IdCustomer: responseCustomer[0].value,
                  KeyRequestUser: selectedUser.Key,
                  Name: projectDataSearch?.Name,
                  IdProject: 0,
                  Limit: projectsListPagination.Limit,
                  Page: 1,
                };
                await dispatch(getAllProjectCustomerList(paramsList));
              } else {
                dispatch({
                  type: ALL_PROJECT_LIST,
                  projectsList: [],
                  projectsListPagination: { Limit: 3, Page: 1, Total: 0 },
                });
              }
            } else if (read("StypeU") === "2" || read("UserC") === "zero") {
              const params = {
                keyGroup: read("groupKey"),
                keyUser: read("userKey"),
              };
              const response = await dispatch(getCustomerList(params));
              dispatch({
                type: SELECTED_CUSTOMER,
                selectedCustomer: response[0],
              });
              const paramsList = {
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
                IdCustomer: response[0].value,
                IdProject: 0,
                Name: projectDataSearch?.Name,
                Limit: projectsListPagination.Limit,
                Page: projectsListPagination.Page,
              };
              await dispatch(getAllProjectCustomerList(paramsList));
            }
            dispatch(
              changeProjectSearch({
                ...projectDataSearch,
                customers: -1,
                changeOut: true,
              }),
            );
          }
          handleDialog();
        }
      } catch (e) {
        showNotify({
          text: t("invalidInformation"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(!main_result);
    }
    setLoading(false);
  };

  const onClear = async () => {
    setCheckValid(false);
    setNewCustomer(false);
    setNoCustomer(false);
    setChange(false);
    setControls({ projectName: { value: row.Name } });
    setControls({ ostan: { value: "" } });
    setControls({ city: { value: "" } });
    setControls({ address: { value: row.Address } });
    setControls({ maliyat: { value: row.Tax.toString() } });
    setControls({ nasb: { value: row.CostInstall.toString() } });
    setControls({ mavadMasrafi: { value: row.CostMaterial.toString() } });
    setControls({ customerGroup: { value: "" } });
    setControls({ customerName: { value: "" } });
    setControls({ mobile: { value: "" } });
    setFormValid({});
    setNewCustomerValid({ customerName: false, mobile: false });
  };

  useEffect(() => {
    if (["1", "5"].includes(read("StypeU")) && read("UserC") === "-") {
      if (selectedUser) {
        if (selectedUser.NameStype === "All") {
          setFormDisable(true);
        } else {
          setFormDisable(false);
        }
      } else {
        setFormDisable(true);
      }
    } else {
      setFormDisable(false);
    }
  }, [selectedUser]);

  const onEnter = async () => {
    setLoading(true);
    await onClear();
    try {
      if (["1", "5"].includes(read("StypeU")) && read("UserC") === "-") {
        const newArr = allCustomerForAdmin.filter((item) => {
          return item.Id !== -1;
        });
        setControls({ customers: { selectItems: newArr } });
        setControls({
          customers: {
            value: newArr.find((item) => item.Id === row.IdCustomer),
          },
        });
      } else {
        const newArr = allCustomers.filter((item) => {
          return item.Id !== -1;
        });
        setControls({ customers: { selectItems: newArr } });
        setControls({
          customers: {
            value: newArr.find((item) => item.Id === row.IdCustomer),
          },
        });
      }
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: selectedUser ? selectedUser.Key : read("userKey"),
      };
      const data = await dispatch(getGrouhMoshtari_v2(params));
      setControls({ customerGroup: { selectItems: data } });
      setControls({ customerGroup: { value: data[0] } });
    } catch (err) {
      console.error("[catch error]", err);
    }
    const ct = AddressList.city.find((c) => c.value === row.IdCity);
    const pr = AddressList.Ostan.find((o) => o.value === ct.ostan);
    const ctSelectItems = AddressList.city.filter((s) => s.ostan === ct.ostan);
    setControls({ ostan: { value: pr } });
    setControls({ city: { value: ct } });
    setControls({ city: { selectItems: ctSelectItems } });
    setLoading(false);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={formDisable}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        TransitionProps={{ onEnter: onEnter }}
        fullWidth
        maxWidth="sm"
      >
        <BackDropLoading loading={loading} />
        <div className="dialogHeader">
          <p>
            <Translator id="virayesh_project" />
          </p>
        </div>
        <DialogContent>
          {!loading ? (
            <Grid container spacing={1}>
              {Object.keys(controls)
                .filter((key) => controls[key].row === 1)
                .map((key, index) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key + index}
                      className={`${key === "projectName" ? "mb-2" : ""}`}
                    >
                      {controls[key].type === "text" && (
                        <Input
                          name={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          placeholder={t(key)}
                          validation={controls[key].validation}
                          checkValid={checkValid}
                          label={<Translator id={key} />}
                          type="text"
                        />
                      )}
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          autoSelect={true}
                          options={controls[key].selectItems}
                          label={
                            controls[key].label ? (
                              <Translator id={controls[key].label} />
                            ) : (
                              <Translator id={key} />
                            )
                          }
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                          disabled={newCustomer}
                          buttonLabel={
                            controls[key].hasFunction ? (
                              <span
                                className={`inner-label-button ${
                                  newCustomer ? "cancel" : "active"
                                }`}
                                onClick={toggleNewCustomer}
                              >
                                {newCustomer ? (
                                  <>
                                    {
                                      controls[key].hasFunction.clickedLabel
                                        .icon
                                    }
                                    {t(
                                      controls[key].hasFunction.clickedLabel
                                        .label,
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {
                                      controls[key].hasFunction.unClickedLabel
                                        .icon
                                    }
                                    {t(
                                      controls[key].hasFunction.unClickedLabel
                                        .label,
                                    )}
                                  </>
                                )}
                              </span>
                            ) : (
                              false
                            )
                          }
                        />
                      )}
                    </Grid>
                  );
                })}
              <Grid
                container
                spacing={1}
                className={`insertNewCustomer ${
                  newCustomer ? "active" : "hide"
                }`}
              >
                {Object.keys(controls)
                  .filter((key) => controls[key].row === 2)
                  .map((key, index) => {
                    return (
                      <Grid
                        item
                        sm={controls[key].col.sm}
                        xs={controls[key].col.xs}
                        key={key + index}
                      >
                        {controls[key].type === "text" && (
                          <Input
                            name={key}
                            setValue={setValue.bind(this)}
                            value={controls[key].value}
                            placeholder={t(key)}
                            validation={controls[key].validation}
                            checkValid={checkValid}
                            label={<Translator id={key} />}
                            type="text"
                          />
                        )}
                        {controls[key].type === "mobile" && (
                          <Input
                            name={key}
                            setValue={setValue.bind(this)}
                            value={controls[key].value}
                            placeholder={t(key)}
                            validation={controls[key].validation}
                            checkValid={checkValid}
                            label={<Translator id={key} />}
                            type="text"
                            className={"phone"}
                            maxlength="11"
                            helperText={"mobileExample"}
                          />
                        )}
                        {controls[key].type === "select" && (
                          <MuiAutoComplete
                            autoSelect={true}
                            options={controls[key].selectItems}
                            label={<Translator id={key} />}
                            value={controls[key].value}
                            id={key}
                            onChange={autoCompleteHandler}
                          />
                        )}
                      </Grid>
                    );
                  })}
              </Grid>
              {Object.keys(controls)
                .filter((key) => controls[key].row === 3)
                .map((key, index) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key + index}
                      className={`${key === "address" ? "mb-3" : ""}`}
                    >
                      {controls[key].type === "text" && (
                        <Input
                          name={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          placeholder={t(key)}
                          validation={controls[key].validation}
                          checkValid={checkValid}
                          label={<Translator id={key} />}
                          type="text"
                        />
                      )}
                      {controls[key].type === "percent" && (
                        <Input
                          name={key}
                          setValue={setValue.bind(this)}
                          defaultValue={controls[key].value}
                          validation={controls[key].validation}
                          endIcon="%"
                          label={<Translator id={key} />}
                          type={controls[key].type}
                        />
                      )}
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          autoSelect={true}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                        />
                      )}
                    </Grid>
                  );
                })}
            </Grid>
          ) : (
            <MuiSkeleton xs={6} number={12} />
          )}
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            className="main-large-button"
            onClick={onFinish}
            title={<Translator id="button_save" />}
            disabled={!change}
          />
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditProjectDialog;
